export const propertyColumns = [
    { Header: 'Property ID', accessor: 'propertyId' },
    { Header: 'Unit Name', accessor: 'unitName' },
    { Header: 'Property Type', accessor: 'propertyType' },
    { Header: 'Contact Person', accessor: 'contactPerson' },
    { Header: 'Mobile No.', accessor: 'mobileNo' },
    { Header: 'Email ID', accessor: 'emailId' },
    { Header: 'Address', accessor: 'address' },
    { Header: 'Actions', accessor: 'actions', Cell: ({ value }) => value },
  ];